import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// IPv4 normalization for fetch requests (avoid IPv6 connection issues)
let backendUrl = process.env.REACT_APP_BACKEND_URL?.trim();

if (backendUrl) {
  try {
    const urlObj = new URL(backendUrl);
    if (urlObj.hostname === 'localhost' || urlObj.hostname === '::1') {
      urlObj.hostname = '127.0.0.1';
      backendUrl = urlObj.toString();
    }
  } catch (e) {
    backendUrl = backendUrl.replace(/localhost/g, '127.0.0.1').replace(/::1/g, '127.0.0.1');
  }
}

if (backendUrl && typeof window !== 'undefined' && window.fetch) {
  const originalFetch = window.fetch;
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    try {
      let urlStr = typeof input === 'string' ? input : input.toString();
      // Normalize localhost to 127.0.0.1 in the request URL
      try {
        const urlObj = new URL(urlStr, window.location.href);
        if (urlObj.hostname === 'localhost' || urlObj.hostname === '::1') {
          urlObj.hostname = '127.0.0.1';
          urlStr = urlObj.toString();
          if (typeof input === 'string') {
            input = urlStr;
          }
        }
      } catch (e) {
        urlStr = urlStr.replace(/localhost/g, '127.0.0.1').replace(/::1/g, '127.0.0.1');
        if (typeof input === 'string') {
          input = urlStr;
        }
      }
    } catch (e) {
      // fall through to default fetch
    }
    return originalFetch(input, init);
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <App />
  </BrowserRouter>
);